export default __webpack_public_path__ + "static/asl-thumb-b3ea7a48a9095bfd0554a369795c310d.jpg";